module.exports = __webpack_public_path__ + "static/service-cs-ht-half-a2dcbe098ed0f3f32d31a39d5fedb7c3.jpg";